export default __webpack_public_path__ + "static/media/tony-dai.118fead5.jpg";